import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=a7e969da&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=ts&"
export * from "./Button.vue?vue&type=script&lang=ts&"
import style0 from "./Button.vue?vue&type=style&index=0&id=a7e969da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e969da",
  null
  
)

export default component.exports